/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Choose_FolderInputs */



/**
* | output |
* | --- |
* | "Choose..." |
*
* @param {Embed_Captions_Local_Choose_FolderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_choose_folder = /** @type {((inputs?: Embed_Captions_Local_Choose_FolderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Choose_FolderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisir...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegliere...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбирать...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elegir...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選ぶ...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चुनना...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escolher...")
	return /** @type {LocalizedString} */ ("Choose...")
});